<template>
  <div>
    <!-- <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mdAndDown" @click.stop="openNav = !openNav" height="18" width="22"></v-app-bar-nav-icon> -->
    <v-btn class="ml-4" light elevation="1" icon v-if="$vuetify.breakpoint.mdAndDown" @click.stop="openNav = !openNav" small>
      <img loading="lazy" src="/static/svg/mobile-profile-open-nav.svg" />
    </v-btn>
    <!-- calc(100vh - 100px) -->
    <v-navigation-drawer
      width="fix-content"
      :height="$vuetify.breakpoint.mdAndDown ? 'calc(100vh - 100px)' : ''"
      class="desktop-navigation-drawer"
      :class="$vuetify.breakpoint.mdAndDown ? 'mt-2 ml-1' : ''"
      v-model="openNav"
      :absolute="$vuetify.breakpoint.mdAndDown ? true : false"
      :left="$vuetify.breakpoint.mdAndDown ? true : false"
      :temporary="$vuetify.breakpoint.mdAndDown ? true : false"
      :permanent="$vuetify.breakpoint.mdAndDown ? false : true"
    >
      <v-col cols="12">
        <div>
          <v-row no-gutters class="pa-3" style="justify-content: space-between;">
            <span class="white--text" style="font-size: 16px">{{ memberInfo ? memberInfo.memberCode : '' }}</span>
            <span style="color: #ffc000; font-size: 16px;">{{ 'VIP Level: ' + currentLevel }}</span>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="vip-card" @click="goToVipTier()">
          <v-row no-gutters class="pa-3 card-row">
            <div><img :src="`/static/svg/vipassets/vip_${tierColorThemeName}.png`" class="left-panel-icon" /></div>
            <div class="level-progress-bar">
              <v-progress-linear rounded :indeterminate="isProgressLoading" height="8px" color="#FF5AE4" background-color="#770073" :value="vipTierProgressPercent"></v-progress-linear>
            </div>
            <div><img :src="`/static/svg/vipassets/vip_${getTierIcon(viptierCurLevel + 1)}.png`" class="left-panel-icon float-right" /></div>

            <v-col cols="12" class="mt-1 text-center">
              <span v-if="tierColorThemeName == 'prestige'" class="progress-text">You have reach the highest rank</span>
              <span v-else class="progress-text">{{ progressLabel }}</span>
              <!--                <div v-if="viptierCurLevel < 7">-->
              <!--                  <span v-if="vipTierProgressPercent === 100 && vipTierUpgrade === null">-->
              <!--                    {{ $t(`label.vipTierPendingUpgrade`) }}-->
              <!--                  </span>-->
              <!--                  <span v-else class="progress-text">{{ vipTierUpgrade ? currentUpgradeDeposit + '/' + requiredUpgradeDeposit : '' }}</span>-->
              <!--                </div>-->
              <!--                <div v-else>-->
              <!--                  <span v-if="vipTierProgressPercent === 100">-->
              <!--                    {{ $t(`label.vipTierRetentionFulFilled`) }}-->
              <!--                  </span>-->
              <!--                  <span v-else class="progress-text">{{ vipTierDowngrade ? currentUpgradeDeposit + '/' + requiredUpgradeDeposit : '' }}</span>-->
              <!--                </div>-->
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex justify-space-around">
          <div class="left-button" @click="navigateToDepositPage">
            <img v-if="this.currentRouteName == routeName.DEPOSIT" src="/static/image/icon/deposit_selected.png" class="left-panel-icon" />
            <img v-else src="/static/image/icon/deposit_round.png" class="left-panel-icon" />
            <span :class="this.currentRouteName == routeName.DEPOSIT ? 'selected_panel' : ''">{{ $t(`label.deposit`) }}</span>
          </div>
          <div class="left-button" @click="navigateToWithdrawPage">
            <img v-if="this.currentRouteName == routeName.WITHDRAWAL" src="/static/image/icon/withdraw_selected.png" class="left-panel-icon" />
            <img v-else src="/static/image/icon/withdraw_round.png" class="left-panel-icon" />
            <span :class="this.currentRouteName == routeName.WITHDRAWAL ? 'selected_panel' : ''">{{ $t(`label.withdrawal`) }}</span>
          </div>
          <div class="left-button" @click="navigateToProfilePage">
            <img v-if="this.currentRouteName == routeName.PERSONAL" src="/static/image/icon/profile_selected.png" class="left-panel-icon" />
            <img v-else src="/static/image/icon/profile_round.png" class="left-panel-icon" />
            <span :class="this.currentRouteName == routeName.PERSONAL ? 'selected_panel' : ''">{{ $t(`label.profile`) }}</span>
          </div>
        </div>
      </v-col>
      <v-list nav dense>
        <v-list-item-group active-class="profile-nav-active">
          <v-list-item v-if="$vuetify.breakpoint.mdAndDown" class="pl-0 nav-btn" active-class="white" @click.stop="openNav = !openNav">
            <v-list-item-title>
              <img loading="lazy" src="/static/svg/mobile-profile-close-nav.svg" />
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title class="nav-title">
              {{ $t(`label.fundsHistory`) }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoBettingRecord()" :aria-selected="false">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-betting-record.png" class="mobile-icon-deposit" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.bettingRecors`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoTurnoverPage()" :aria-selected="false">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-turnover.png" class="mobile-icon-deposit" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.turnoverRecords`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoTransactionPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-transfer-record.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.transactionRecords`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoBonusReportPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-bonus.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.bonusReport`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button">
            <v-list-item-title class="nav-title">
              {{ $t(`label.profile`) }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="profile-nav-button" :to="{ name: routeName.PERSONAL, params: { lang: this.$route.params.lang } }">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-personal-info.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.personalInfo`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoChangePasswordPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-change-password.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.changePassword`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="gotoBankDetailPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-bank-details.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.bankDetails`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button">
            <v-list-item-title class="nav-title">
              {{ $t(`label.rewards`) }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="goToDailyCheckIn()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-check-in.png" class="mobile-icon-deposit" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.dailyCheckIn`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="goToWOFPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/icon-wof.png" class="mobile-icon-deposit" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`luckyWheel.spintitle`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="navigateToVoucherPage()">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-claim-voucher.png" class="mobile-icon-deposit" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.claimVoucher`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button">
            <v-list-item-title class="nav-title">
              {{ $t(`label.other`) }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="profile-nav-button" :to="{ name: routeName.INBOX, params: { lang: this.$route.params.lang } }">
            <v-list-item-icon>
              <img loading="lazy" src="/static/image/profile/profile-inbox.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`button.inbox`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" @click="downloadAPK()">
            <v-list-item-icon>
              <img loading="lazy" width="30" height="30" src="/static/image/profile/profile-download-app.png" class="mobile-icon" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.downloadApp`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="profile-nav-button" v-if="false" @click="goToTutorialVideoGuide()">
            <v-list-item-icon>
              <account-password class="mobile-icon"></account-password>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ $t(`label.videoGuide`) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { DevicePlatform } from '@/constants/enums'
import { ROUTE_NAME } from '@/constants/route.constants'
import { locale, uiHelper } from '@/util'
import AccountBank from '@/assets/svg/profile/bank.svg'
import AccountDeposit from '@/assets/svg/profile/deposit.svg'
import AccountHistory from '@/assets/svg/profile/history.svg'
import AccountInbox from '@/assets/svg/profile/inbox.svg'
import AccountPassword from '@/assets/svg/profile/password.svg'
import AccountProfile from '@/assets/svg/profile/profile.svg'
import AccountReward from '@/assets/svg/profile/reward.svg'
import AccountVip from '@/assets/svg/profile/vip.svg'
import AccountWithdrawal from '@/assets/svg/profile/withdrawal.svg'
import { MEMBER_VIP_TIER_PROGRESS } from '@/store/member.module'
import { REFERRAL_RESET_COMMISSION } from '@/store/referral.module'
export default {
  name: 'appBankAndProfileSidePanel',
  components: {
    AccountBank,
    AccountDeposit,
    AccountHistory,
    AccountInbox,
    AccountPassword,
    AccountProfile,
    AccountReward,
    AccountVip,
    AccountWithdrawal
  },
  data: () => ({
    devicePlatform: DevicePlatform,
    uihelper: uiHelper,
    openNav: false,
    currentUpgradeDeposit: 0,
    requiredUpgradeDeposit: 0,
    tierColorThemeName: 'club',
    viptierCurLevel: -1,
    currentLevel: 'member',
    routeName: ROUTE_NAME,
    progressLabel: '',
    vipTierProgressPercent: 0,
    progressValue: 0,
    isProgressLoading: true,
    bankLink: [
      {
        text_key: 'deposit',
        routeName: ROUTE_NAME.DEPOSIT
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.WITHDRAWAL
      },
      {
        text_key: 'transfer',
        routeName: ROUTE_NAME.TRANSFER
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.TRANSACTION_HISTORY
      },
      {
        text_key: 'player-history',
        routeName: ROUTE_NAME.PLAYER_HISTORY
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.BANK_ACCOUNT
      }
    ],
    profileLink: [
      {
        text_key: 'account',
        routeName: ROUTE_NAME.PROFILE
      },
      {
        text_key: 'personal',
        routeName: ROUTE_NAME.PERSONAL
      },
      {
        text_key: 'announcement',
        routeName: ROUTE_NAME.ANNOUNCEMENT
      }
    ],
    affiliateLink: [
      {
        text_key: 'qrCode',
        routeName: ROUTE_NAME.AFFILIATE_LINK
      },
      {
        text_key: 'withdrawal',
        routeName: ROUTE_NAME.AFFILIATE_WITHDRAWAL
      },
      {
        text_key: 'history',
        routeName: ROUTE_NAME.AFFILIATE_TRANSACTION
      },
      {
        text_key: 'bankAccount',
        routeName: ROUTE_NAME.AFFILIATE_BANK_ACCOUNT
      }
    ]
  }),
  created() {
    if (this.vipProgress && this.vipProgress.required_deposit_amount >= 0 && this.vipProgress.current_deposit_progress >= 0) {
      this.progressValue = (this.vipProgress.current_deposit_progress / this.vipProgress.required_deposit_amount) * 100
      this.isProgressLoading = false
      this.vipProgressLevel = this.vipProgress.current_level_name.indexOf('Level') != -1 ? this.vipProgress.current_level_name.split(' ')[1] : ''
    }
    this.getVipTierProgress()
    this.setVipTierLevel()
  },
  computed: {
    currentRouteName() {
      console.log(this.$route.name)
      return this.$route.name
    },
    uiHelper() {
      return uiHelper
    },
    vipTierDowngrade() {
      return this.$store.state.member.vipTierProgress.downgrade
    },
    vipTierUpgrade() {
      return this.$store.state.member.vipTierProgress.upgrade
    },
    memberVipTierProgress() {
      return this.$store.state.member.vipTierProgress.pairing
    },
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    },
    memberInfo() {
      return this.$store.state.member.info
    },
    watchVipCurLevel() {
      return this.viptierCurLevel
    },
    vipProgress() {
      return this.$store.state.member.vipProgress
    }
  },
  watch: {
    watchVipCurLevel() {
      this.setTierIcon()
      this.setVipTierDetails()
    },
    memberVipTierProgress() {
      this.setVipTierLevel()
    },
    vipTierUpgrade() {},
    isLoggedIn() {
      this.getVipTierProgress()
    },
    vipProgress() {
      this.isProgressLoading = false
      let progress = this.$store.state.member.vipProgress
      if (progress && progress.required_deposit_amount && progress.current_deposit_progress) {
        this.progressValue = (progress.current_deposit_progress / progress.required_deposit_amount) * 100
        this.vipProgressLevel = progress.current_level_name.indexOf('Level') != -1 ? progress.current_level_name.split(' ')[1] : ''
      }
    }
  },
  methods: {
    downloadAPK() {
      uiHelper.downloadAPK()
    },
    goToRewardPage() {
      this.$router.push({
        name: ROUTE_NAME.REWARDS,
        params: {
          lang: this.$route.params.lang,
          tab: 'moreRewards'
        }
      })
    },
    goToDailyCheckIn() {
      this.$router.push({
        name: ROUTE_NAME.REWARDS,
        params: {
          lang: this.$route.params.lang,
          tab: 'dailyCheckIn'
        }
      })
    },
    goToVipTier() {
      this.$router.push({
        name: ROUTE_NAME.VIPTIER,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    navigateToVoucherPage() {
      if (!this.isLoggedIn) {
        return this.$parent.openLoginDialog()
      }
      this.$router.push({
        name: ROUTE_NAME.CLAIM_VOUCHER,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    goToWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
    },
    gotoChangePasswordPage() {
      this.$router.push({
        name: ROUTE_NAME.CHANGE_PASSWORD,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    goToTutorialVideoGuide() {
      this.$router.push({
        name: ROUTE_NAME.VIDEO_GUIDE,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoBankDetailPage() {
      this.$router.push({
        name: ROUTE_NAME.BANK_ACCOUNT,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoBonusReportPage() {
      this.$router.push({
        name: ROUTE_NAME.BONUS_HISTORY,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoTransactionPage() {
      this.$router.push({
        name: ROUTE_NAME.TRANSACTION_HISTORY,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoTurnoverPage() {
      this.$router.push({
        name: ROUTE_NAME.TURNOVER_RECORD,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    gotoBettingRecord() {
      this.$router.push({
        name: ROUTE_NAME.BETTING_HISTORY,
        params: {
          lang: this.$route.params.lang
        }
      })
    },
    setTierIcon() {
      switch (this.viptierCurLevel) {
        case 0:
          this.tierColorThemeName = 'newMember'
          break
        case 1:
          this.tierColorThemeName = 'copper'
          break
        case 2:
          this.tierColorThemeName = 'bronze'
          break
        case 3:
          this.tierColorThemeName = 'silver'
          break
        case 4:
          this.tierColorThemeName = 'gold'
          break
        case 5:
          this.tierColorThemeName = 'platinum'
          break
        case 6:
          this.tierColorThemeName = 'diamond'
          break
        case 7:
          this.tierColorThemeName = 'prestige'
          break
      }
    },
    setVipTierLevel() {
      if (this.memberVipTierProgress && this.memberVipTierProgress.level_sequence != undefined) {
        this.viptierCurLevel = this.memberVipTierProgress.level_sequence
        this.currentLevel = this.memberVipTierProgress.name
      }
    },
    setVipTierDetails() {
      if (this.viptierCurLevel >= 0 && this.viptierCurLevel < 6) {
        if (this.vipTierUpgrade) {
          if (this.vipTierUpgrade.required_upgrade_deposit && this.vipTierUpgrade.required_upgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierUpgrade.required_upgrade_deposit)
          }

          if (this.vipTierUpgrade.current_upgrade_deposit && this.vipTierUpgrade.current_upgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierUpgrade.current_upgrade_deposit)
          }
          const nextLevel = this.getTierIcon(this.viptierCurLevel + 1)
          const nextLevelDeposit = this.requiredUpgradeDeposit - this.currentUpgradeDeposit
          this.progressLabel = locale.getMessage(`label.vipTierUpgradeTo`, [nextLevel.toLocaleUpperCase()])
        } else {
          if (this.vipTierUpgrade == null) {
            //pending upgrade tier
            this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
          }
        }
      } else {
        ///highest tier level in automation = 6 , level 7 is manual upgrade rquired
        if (this.vipTierDowngrade) {
          if (this.vipTierDowngrade.required_downgrade_deposit && this.vipTierDowngrade.required_downgrade_deposit >= 0) {
            this.requiredUpgradeDeposit = Number(this.vipTierDowngrade.required_downgrade_deposit)
          }

          if (this.vipTierDowngrade.current_downgrade_deposit && this.vipTierDowngrade.current_downgrade_deposit >= 0) {
            this.currentUpgradeDeposit = Number(this.vipTierDowngrade.current_downgrade_deposit)
          }
          const nextLevel = this.getTierIcon(this.viptierCurLevel + 1)
          const nextLevelDeposit = this.requiredUpgradeDeposit - this.currentUpgradeDeposit
          this.progressLabel = locale.getMessage(`label.vipTierUpgradeTo`, [nextLevel.toLocaleUpperCase()])
        } else {
          //check for whether retention fulfilled
          if (this.vipTierDowngrade == null && this.vipTierUpgrade == null) {
            this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
          }
        }
      }

      if (this.requiredUpgradeDeposit > 0) {
        this.vipTierProgressPercent = Math.ceil((this.currentUpgradeDeposit / this.requiredUpgradeDeposit) * 100)
      } else {
        //assume Denominator = 0 mean no need to upgrade / fulfilled
        //either retention fulfilled or pending upgrade
        this.vipTierProgressPercent = 100
      }

      //regarding upgrade/downgrade is null or not as long we 100% then display fulfillment message
      if (this.vipTierProgressPercent === 100) {
        if (this.viptierCurLevel < 6) {
          this.progressLabel = locale.getMessage(`label.vipTierPendingUpgrade`)
        } else {
          this.progressLabel = locale.getMessage(`label.vipTierRetentionFulFilled`)
        }
      }
    },
    getVipTierProgress() {
      if (this.isLoggedIn) {
        this.$store.dispatch(MEMBER_VIP_TIER_PROGRESS)
      }
    },
    getTierIcon(nextLevel) {
      switch (nextLevel) {
        case 0:
          return 'newMember'
        case 1:
          return 'copper'
        case 2:
          return 'bronze'
        case 3:
          return 'silver'
        case 4:
          return 'gold'
        case 5:
          return 'platinum'
        case 6:
          return 'diamond'
        case 7:
          return 'prestige'
      }
    },
    navigateToDepositPage() {
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            lang: this.$route.params.lang,
            tab: 'deposit'
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.DEPOSIT,
          params: {
            tab: 'deposit'
          }
        })
      }
    },
    navigateToWithdrawPage() {
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.WITHDRAWAL,
          params: {
            lang: this.$route.params.lang,
            tab: 'withdrawal'
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.WITHDRAWAL,
          params: {
            tab: 'withdrawal'
          }
        })
      }
    },
    navigateToProfilePage() {
      if (this.$route.params.lang) {
        this.$router.push({
          name: ROUTE_NAME.PERSONAL,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.PERSONAL
        })
      }
    }
  }
}
</script>

<style lang="scss">
.desktop-navigation-drawer {
  background: transparent linear-gradient(134deg, #3d3360 0%, #0f0a20 100%) 0 0 no-repeat padding-box !important;
  font-size: 12px;
  border-radius: 8px;
  height: 660px;

  .v-navigation-drawer__content {
    -ms-overflow-style: none; /* Hide IE scrollbar */
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    height: 5px; /* Adjust height for horizontal scrollbar */
    width: 10px;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background-color: #ffc000 !important;
    border-radius: 10px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-track {
    background: #3d3360; /* Track color */
    border-radius: 10px;
  }
  .vip-card {
    .card-row {
      justify-content: space-between;

      .level-progress-bar {
        width: calc(100% - 100px);
        place-self: center;
      }

      .left-panel-icon {
        width: 32px;
      }

      .progress-text {
        font-size: 11px;
        color: white;
      }
    }
  }

  .left-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    img {
      width: 52px;
      //padding: 6px;
      //background: transparent linear-gradient(180deg, #770073 0%, #0e181d 100%) 0% 0% no-repeat padding-box;
      //border-radius: 24px;
    }

    span {
      font-size: 14px;
      color: white;
    }
    .selected_panel {
      color: #ffc000;
    }
  }

  .nav-title {
    color: white;
  }
  .profile-nav-button {
    padding: 0px !important;
    .v-list-item__title {
      color: white !important;
    }
    .v-list-item__icon {
      margin-right: 0px !important;
      width: 60px;
      justify-content: center;
    }

    .mobile-icon {
      fill: #ffc000;
      path {
        fill: #ffc000;
      }
    }
    .mobile-icon-deposit {
      fill: #ffc000 !important;
    }
    // &:hover {
    //   color: #0C2AAB !important;
    //   .mobile-icon {
    //     fill: #0C2AAB !important;
    //     path {
    //       fill: #0C2AAB !important;
    //     }
    //   }
    //   .mobile-icon-deposit{
    //     fill: #0C2AAB !important;
    //   }
    // }
  }
  .profile-nav-active .v-list-item__title {
    color: #ffc000 !important;
  }
  .nav-btn.theme--light.v-list-item--active::before {
    opacity: 0 !important;
  }
}
.profile-nav-active {
  //background-color: #3a3a3a !important;
  color: #fff !important;
  .mobile-icon {
    fill: #fff !important;
    path {
      fill: #fff !important;
    }
  }
  .v-list-item__title {
    color: #ffc000 !important;
  }
}
</style>
